import { render, staticRenderFns } from "./AttachExistingLessonDialog.vue?vue&type=template&id=5b28d9ee&"
import script from "./AttachExistingLessonDialog.vue?vue&type=script&lang=ts&"
export * from "./AttachExistingLessonDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports